/**
 * @generated SignedSource<<fa478c23191446b11512bcf26f59f45e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSkills_account$data = {
  readonly skills: ReadonlyArray<{
    readonly id: number;
    readonly name: string;
  }>;
  readonly " $fragmentType": "useSkills_account";
};
export type useSkills_account$key = {
  readonly " $data"?: useSkills_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSkills_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSkills_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "skills",
      "kind": "LinkedField",
      "name": "skills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "128dae5738a247c2f16a602ed04ae2df";

export default node;
